module.exports = __webpack_public_path__ + "img/teaser_240x200_pkimmobilien.ba4cd969.jpg";